import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ViewsService } from '../../../services/views.service';
import { Lightbox } from 'ngx-lightbox';
import { SchemasService } from '../../../services/schemas.service';
import { BroadcastService, BroadcastEventModel } from '@cv-invision/core';
import { FORM_EVENT } from '../../../models/enums.model';

@Component({
	selector: 'cv-invision-photo-gallery',
	templateUrl: './photo-gallery.component.html',
	styleUrls: ['./photo-gallery.component.scss']
})
export class PhotoGalleryComponent implements OnInit, OnDestroy {
	@Input() path: string | null;
	@Input() options: any = {};

	get photos(): any {
		return this.viewsService.photos;
	}
	get photosSelected(): any {
		return this.viewsService.photosSelected;
	}

	isEditing = false;

	images = [];
	album = [];

	bc;

	constructor(
		private changeDetectorRef: ChangeDetectorRef,
		private viewsService: ViewsService,
		private schemasService: SchemasService,
		private broadcastService: BroadcastService,
		private lightbox: Lightbox
	) {
		this.bc = this.broadcastService.on(FORM_EVENT.DYNAMIC_FORM_EDITABLE, (broadcast: BroadcastEventModel) => {
			this.isEditing = broadcast.event.isEditing;
			// console.log('broadcast', this.isEditing);
			// Force view to immediate render
			this.changeDetectorRef.markForCheck();
		});
		// console.log('afterBradcast', this.isEditing);
	}

	ngOnInit(): void {
		if (this.path) {
			this.loadImages();
		}
	}

	ngOnDestroy(): void {
		this.bc();
	}

	/**
	 * initialize the image variable with the images for certain section.
	 * ToDo:
	 * - Put 1004 ready
	 */
	async loadImages(): Promise<void> {
		this.images = [];
		this.album = [];

		const photoPath = `@.refJsonPath=='${this.path}'`;
		const images = this.schemasService.query2(this.photos, `$..[?(${photoPath})]`);

		images.then(data => {
			this.images = [...data];
			data.forEach(img => {
				// const image = {
				// 	small: img.thumbnails[0],
				// 	medium: img.thumbnails[0],
				// 	big: img.path,
				// 	src: img.path
				// };
				const image = {
					src: img.path,
					caption: '',
					thumb: ''
				};
				this.album.push(image);
			});
			// Ensure the images are loaded every time
			this.changeDetectorRef.markForCheck();
		});
		// console.log('loadImages', this.isEditing);
	}

	/**
	 * Open lightbox
	 * @param index 
	 */
	openGallery(data: any): void {
		const photoIndex = this.images.indexOf(data.photo);

		if (photoIndex > -1) {
			this.lightbox.open(this.album, photoIndex);
		}
	}

	/**
	 * update main photo and send the broadcast event
	 * @param event 
	 */
	setMainPhoto(event: any): void {
		const photo = event.photo;
		this.photos.map(p => {
			if (p.refJsonPath === photo.refJsonPath) {
				if (p.id === photo.id) {
					p.metadata.isPrimary = !p.metadata.isPrimary;
				} else {
					p.metadata.isPrimary = false;
				}
			}			
		});

		this.broadcastService.broadcast({
			name: FORM_EVENT.PHOTO_PRIMARY,
			event: {
				data: JSON.parse(JSON.stringify(this.photos))
			}
		});
	}

	/**
	 * set or remove from the selected photos array
	 * @param event 
	 */
	selectedPhoto(event: any): void {
		const index = this.photosSelected.indexOf(event.photo.id);
		if (index > -1) {
			this.photosSelected.splice(index, 1);
		} else {
			this.photosSelected.push(event.photo.id);
		}
		this.broadcastService.broadcast({
			name: FORM_EVENT.PHOTO_SELECT,
			event: {
				data: this.photosSelected
			}
		});
	}

}
